import bg_1 from "@/components/Hero/bg_1.webp";
import { Back } from "@/ui/Back";
import { SocialLink } from "@/ui/SocialLink";
import { TeamMemberImage } from "@/ui/TeamMemberImage";
import cn from "classnames";
import { Card, Container, Ratio } from "react-bootstrap";
import { Parallax } from "react-scroll-parallax";

import classes from "./styles.module.scss";

export default function ({
  className,
  title,
  name,
  image,
  linkedin,
  email,
  EditableImage,
  theme = "light",
}) {
  return (
    <Card className={cn(className, classes.TeamMemberHero)} data-bs-theme={theme}>
      <Parallax translateY={[-80, 40]}>
        <img src={bg_1} className={classes.bg_1} alt="" />
        <Card.Img as={Ratio} aspectRatio={34}>
          <EditableImage path="image" src="/assets/default_hero.webp" size="1920x547" />
        </Card.Img>
      </Parallax>
      <Card.ImgOverlay className="d-flex flex-column text-center align-items-center justify-content-center pt-6 pb-4 pb-lg-5 pt-lg-5">
        <Container fluid="lg" className="pb-lg-5">
          <Back className="mb-lg-6" href="/about-us/meet-team">
            Back to Meet the Team
          </Back>
          <div className="d-flex flex-column align-items-center">
            <TeamMemberImage className={classes.img} src={image} alt={name} hoverable={false} />
            <Card.Header className="small mb-3">{title}</Card.Header>
            <h1 dangerouslySetInnerHTML={{ __html: name }} />
            <Card.Footer>
              {linkedin && <SocialLink href={linkedin} icon="linkedin" />}
              {email && <SocialLink href={`mailto:${email}`} icon="email" />}
            </Card.Footer>
          </div>
        </Container>
      </Card.ImgOverlay>
    </Card>
  );
}
